// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1467":"54dfa112","4227":"ba744218","5537":"cd04bf6f","6483":"7547956f"}[chunkId] + ".chunk.css";
};